import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
export class SetExternArbetsorderTransportforetagCommand extends BasicCommand<SetExternArbetsorderTransportforetagCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    transportforetagId?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetExternArbetsorderTransportforetagCommand";
    constructor(init: (instance: SetExternArbetsorderTransportforetagCommand) => void) {
        super("SetExternArbetsorderTransportforetagCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
